<template>
    <main-layout>
        <template #header>
            <main-header :title="'회원가입시 안내 메일 발송 리스트(MPS 담당자)' | translate">
            </main-header>
        </template>

        <template #toolbar>
        </template>

        <template #body>
            <div style="display: flex; align-items: center;" class="mb-3">
                <div style="display: flex; align-items: center;">
                    <div style="width: 200px;" class="mr-3">
                        <v-text-field v-model="requestAdd.codeKey" outlined dense placeholder="담당자 이름" hide-details></v-text-field>
                    </div>
                    <div style="width: 300px;" class="mr-3">
                        <v-text-field v-model="requestAdd.codeValue" outlined dense placeholder="support@tinteccnc.com" hide-details></v-text-field>
                    </div>
                    <v-btn color="primary" @click="onClickAdd">이메일 추가</v-btn>
                </div>
                <v-spacer></v-spacer>
                <div class="ml-5">
                    <v-btn icon @click="onClickRefresh">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </div>
                <div style="width: 500px; display: none;">
                    <search-bar
                            v-model="searchOptions.searchKeyword"
                            :placeholder="'담당자/이메일' | translate"
                            reactivity="input"
                    />
                </div>
            </div>
            <vue-data-table
                    ref="dataTable"
                    :fetch="fetch"
                    :headers="headers"
                    :identifier="identifier"
                    :search="searchOptions.searchKeyword"
                    :reload="reload"
                    item-key="raw.codeId"
                    infinite-pagination
                    :items-per-page="30"
            >
                <template #item.update="{ item }">
                    <charge-email-signup-edit-modal
                            :item="item"
                            @update="identifier++"
                    ></charge-email-signup-edit-modal>
                </template>
                <template #item.delete="{ item }">
                    <v-btn icon @click="onClickDelete(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </vue-data-table>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainHeader from "@/components/common/layout/MainHeader";
    import SearchBar from "@/components/input/SearchBar";
    import {PATH} from "@/constants";
    import ChargeEmailSignupEditModal from "@/views/charge-email/modal/ChargeEmailSignupEditModal";
    export default {
        name: "ChargeEmailSignupManage",
        components: {ChargeEmailSignupEditModal, SearchBar, MainHeader, MainLayout},
        data() {
            return {
                searchOptions: {
                    searchKeywrod: "",
                },
                requestAdd: {
                    codeKey: "", // 담당자 이름
                    codeValue: "", // 담당자 이메일
                },
                identifier: 0,
                reload: 0,
                headers: [
                    {
                        text: "담당자",
                        value: "codeKey",
                        width: 200,
                    },
                    {
                        text: "안내메일 발송 이메일",
                        value: "codeValue",
                        width: 1000,
                        align: "start",
                    },
                    {
                        text: "수정",
                        value: "update",
                        width: 100,
                        align: "center",
                        sortable: false,
                    },
                    {
                        text: "삭제",
                        value: "delete",
                        width: 100,
                        align: "center",
                        sortable: false,
                    },
                ],
            }
        },
        methods: {
            async fetch() {
                const res = await this.$request(PATH.CODE.LIST)
                    .setObject({codeType: "CHARGE_EMAIL_SIGNUP"})
                    .enqueue();
                return res.data;
            },

            onClickRefresh() {
                this.identifier++;
            },

            async onClickAdd() {
                const codeKey = (this.requestAdd.codeKey || "").trim();
                const codeValue = (this.requestAdd.codeValue || "").trim();
                if (!codeKey || !codeValue) {
                    this.$alert("담당자 이름과 담당자 이메일을 입력하세요.<br>앞 뒤의 공백문자는 무시합니다.");
                    return;
                }
                await this.$requestWithOverlay(PATH.CODE.CREATE)
                    .setObject({
                        codeKey: codeKey,
                        codeValue: codeValue,
                        codeType: "CHARGE_EMAIL_SIGNUP",
                        language: "ko-KR",
                    })
                    .enqueue();
                this.requestAdd.codeKey = "";
                this.requestAdd.codeValue = "";
                this.identifier++;
            },

            onClickDelete(item) {
                this.$confirm("정말 삭제하시겠습니까?")
                    .then(async () => {
                        await this.$requestWithOverlay(PATH.CODE.DELETE)
                            .setObject({
                                codeId: item.codeId,
                            })
                            .enqueue();
                        this.identifier++;
                    });
            },
        },
    }
</script>

<style scoped>

</style>
